import { ItemHiddenStateOnMenu } from '@biteinc/enums';

import { priceWithDefaultMods } from '~/app/js/utils/price.utils';

import { GCNModel } from './gcn_model';

export const GCNPriceOption = GCNModel.extend({
  initialize(...args) {
    GCNModel.prototype.initialize.apply(this, args);

    this.addonSets = [];
  },

  getPrice() {
    return gcn.menu.shouldDisplayPriceWithDefaultMods()
      ? this.getPriceIncludingDefaultMods()
      : this.get('price');
  },

  getPriceForAddonsSelectedByDefault(addonIdsSelectedByDefault) {
    let total = 0;
    addonIdsSelectedByDefault.forEach((defaultAddon) => {
      const defaultAddonId = defaultAddon._id;
      const modifier = gcn.menu.getMenuItemWithId(defaultAddonId);
      // A modifier with multiple price options cannot be a default modifier.
      if (modifier.priceOptions.length !== 1) {
        return 0;
      }
      const modPriceOption = modifier.priceOptions[0];
      const addonPrice = defaultAddon.price ?? (modPriceOption.get('price') || 0);
      total += addonPrice;

      if (modPriceOption.addonSets?.length) {
        modPriceOption.addonSets.forEach((addonSet) => {
          const nestedAddonSelectedByDefault = addonSet.getAddonIdsAndPricesSelectedByDefault();
          if (nestedAddonSelectedByDefault.length) {
            total += this.getPriceForAddonsSelectedByDefault(nestedAddonSelectedByDefault);
          }
        });
      }
    });
    return total;
  },

  getPriceIncludingDefaultMods() {
    return priceWithDefaultMods(this);
  },

  isHidden() {
    return (
      (this.get('i9nHiddenState') &&
        this.get('i9nHiddenState') !== ItemHiddenStateOnMenu.Shown &&
        this.get('i9nHiddenState') !== ItemHiddenStateOnMenu.ShownButUnavailable) ||
      (this.get('hiddenState') &&
        this.get('hiddenState') !== ItemHiddenStateOnMenu.Shown &&
        this.get('hiddenState') !== ItemHiddenStateOnMenu.ShownButUnavailable)
    );
  },

  isDefault() {
    if (this.get('selectedByDefaultQuantity') === undefined) {
      return !!this.get('i9nSelectedByDefault');
    }

    return !!this.get('selectedByDefaultQuantity');
  },

  getMacronutrientsHtml() {
    if (!this.shouldShowMacronutrients()) {
      return undefined;
    }

    const fat = this.getMacronutrient('fatContent') ?? this.getMacronutrient('posFatContent') ?? 0;
    const protein =
      this.getMacronutrient('proteinContent') ?? this.getMacronutrient('posProteinContent') ?? 0;
    const carbohydrates =
      this.getMacronutrient('carbohydrateContent') ??
      this.getMacronutrient('posCarbohydrateContent') ??
      0;
    const sugar = this.getMacronutrient('sugarContent') ?? this.getMacronutrient('posSugarContent');

    if (!fat && !protein && !carbohydrates && !sugar) {
      return undefined;
    }

    // Only include sugar if it is greater than 0
    return `<div class="macronutrient-table">
              <div class="macronutrient-column">
                <div class="macronutrient-label">Fat</div>
                <div class="macronutrient-value">${fat}g</div>
              </div>
              <div class="macronutrient-column">
                <div class="macronutrient-label">Protein</div>
                <div class="macronutrient-value">${protein}g</div>
              </div>
              <div class="macronutrient-column">
                <div class="macronutrient-label">Carbs</div>
                <div class="macronutrient-value">${carbohydrates}g</div>
              </div>
              ${
                sugar !== null
                  ? `<div class="macronutrient-column">
                        <div class="macronutrient-label">Sugar</div>
                        <div class="macronutrient-value">${sugar}g</div>
                     </div>`
                  : ''
              }
            </div>`;
  },

  getMacronutrient(nutrient) {
    const nutritionInfo = this.get('nutritionInfo');
    if (!nutritionInfo) {
      return null;
    }
    const macro = nutritionInfo[nutrient];
    if (isNaN(macro)) {
      return null;
    }
    return macro;
  },

  shouldShowMacronutrients() {
    if (!gcn.menu.settings.get('showNutritionInfo')) {
      return false;
    }
    if (this.getMacronutrient('carbohydrateContent') !== null) {
      return true;
    }
    if (this.getMacronutrient('posCarbohydrateContent') !== null) {
      return true;
    }
    if (this.getMacronutrient('sugarContent') !== null) {
      return true;
    }
    if (this.getMacronutrient('posSugarContent') !== null) {
      return true;
    }
    if (this.getMacronutrient('proteinContent') !== null) {
      return true;
    }
    if (this.getMacronutrient('posProteinContent') !== null) {
      return true;
    }
    if (this.getMacronutrient('fatContent') !== null) {
      return true;
    }
    if (this.getMacronutrient('posFatContent') !== null) {
      return true;
    }
    return false;
  },
});
